import Routes from './routes'
import ReducerFuncs from './store'

const Reducers = (reducerObj) => { reducerObj.products = ReducerFuncs }

export {
  Routes,
  Reducers
}
